module.exports = "<input class=smss-input tabindex=0 ng-transclude/> ";